import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getFindProductCategoryKey, getSuggestedProductsKey } from './products.keys';
import { findProductCategory, findSuggestedProductColors } from './products.repository';
import {
  FindProductCategoryOutput,
  GetSuggestedProducts,
  GetSuggestedProductsResponse,
} from './products.types';

export const useFindProductCategory = (
  productId: string,
  options?: UseDataQueryOptions<FindProductCategoryOutput | null>,
) =>
  useDataQuery<FindProductCategoryOutput | null>(
    {
      queryKey: getFindProductCategoryKey(productId),
      queryFn: async () => {
        const response = await findProductCategory(productId);

        if (!response.ok) {
          throw response.originalError;
        }

        return response.data ?? null;
      },
    },
    options,
  );

export const useSuggestedProducts = (params: GetSuggestedProducts, options?: UseDataQueryOptions) =>
  useDataQuery<GetSuggestedProductsResponse | undefined>(
    {
      queryKey: getSuggestedProductsKey(params),
      gcTime: 0,
      queryFn: async () => {
        const { customerIds, productIds, mainCustomerId, catalogEntityIds } = params;

        const response = await findSuggestedProductColors({
          customerIds,
          productIds,
          mainCustomerId,
          catalogEntityIds,
        });

        return response.data;
      },
    },
    options,
  );
